import React from "react";
import { LoadingOverlay, Paper, Space, Tabs, Text } from "@mantine/core";
import { PageLayout } from "../layout";
import { ScfSupplierInformationForm } from "./information-form";
import { ScfSupplierRequestList } from "../scf-request/list";
import useSwr from "swr";
import { RequestApi } from "../../apis";
import { useNavigate, useParams } from "react-router";
import { IconArticle, IconClipboardText } from "@tabler/icons";
import { useSelector } from "react-redux";
import { IAuth } from "../../interfaces/IAuth";

export function ScfSupplierRequestTabs() {
  const params = useParams();
  const { id, step } = params;
  const breadcrumbs = useBreadcrumb();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = React.useState(step || "1");
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);

  const { data: requestData } = useSwr<any>(`table.scf-programm-supplier.led.${params.id}`, async () => await RequestApi.getSupplier(`${id}`));

  const onTabChange = (_index: any) => {
    navigate(`/scf/request/SUPPLIER/${params.id}/${_index}`);
    setTabIndex(_index);
  };

  return (
    <PageLayout
      title={`${requestData?.anchor?.partner?.refCode}, ${requestData?.anchor?.partner?.businessName}`}
      subTitle={`${requestData?.anchor?.refCode}# ${requestData?.anchor?.profileName}, ${requestData?.anchor?.regNumber}, supplier led хүсэлтийн жагсаалт`}
      breadcrumb={breadcrumbs}>
      <Paper radius="sm" p="md" withBorder>
        <LoadingOverlay visible={!requestData} />
        {requestData && (
          <Tabs defaultValue="1" value={tabIndex} onTabChange={onTabChange}>
            <Tabs.List>
              <Tabs.Tab value="1" icon={<IconArticle color={tabIndex === "1" ? "#3e166e" : "#44566C"} />}>
                <Text size="sm" weight={500} c="#44566C">
                  Үндсэн мэдээлэл
                </Text>
              </Tabs.Tab>
              {(user?.permissions || []).filter((c) => c.module === "SCF" && c.code === "SCF_REQUEST_MANAGEMENT_SL" && c.isView).length > 0 && (
                <Tabs.Tab value="2" icon={<IconClipboardText color={tabIndex === "2" ? "#3e166e" : "#44566C"} />}>
                  <Text size="sm" weight={500} c="#44566C">
                    Хүсэлтүүд
                  </Text>
                </Tabs.Tab>
              )}
            </Tabs.List>
            <Space h="md" />
            <Tabs.Panel value="1">{tabIndex === "1" && requestData && <ScfSupplierInformationForm setIndex={onTabChange} data={requestData} />}</Tabs.Panel>
            {(user?.permissions || []).filter((c) => c.module === "SCF" && c.code === "SCF_REQUEST_MANAGEMENT_SL" && c.isView).length > 0 && (
              <Tabs.Panel value="2">{tabIndex === "2" && requestData && <ScfSupplierRequestList setIndex={setTabIndex} data={requestData} />}</Tabs.Panel>
            )}
          </Tabs>
        )}
      </Paper>
    </PageLayout>
  );
}

const useBreadcrumb = () => [
  {
    to: "/",
    label: "Үндсэн",
  },
  {
    to: "/scf/request/SUPPLIER",
    label: "Supplier LED хүсэлт",
  },
  {
    label: "Хүсэлт шийдвэрлэх",
  },
];
